import BaseComponent from './BaseComponent';


const texts_es = ['Solo para profesionales, autónomos y empresas', 'Todo nuestro catálogo a precios profesionales', 'Además de la tarifa PRO, te enviaremos cupones y ofertas especiales', 'También te activaremos los descuentos por volumen (más unidades, menor precio)']
const texts_en = [ 'Only for professionals, freelancers, and companies', 'Access our entire catalog at professional prices', 'In addition to the PRO rate, we will send you coupons and special offers', 'We will also activate volume discounts (more units, lower price)']
const texts_fr = ['Uniquement pour les professionnels, les indépendants et les entreprises',' Tout notre catalogue à des prix professionnels', 'En plus du tarif PRO, nous vous enverrons des coupons et des offres spéciales', "Nous activerons également les réductions de volume (plus d'unités, moindre coût)"]
class SliderVertical extends BaseComponent {
  constructor(componentName, autoInit = true){
    super(componentName);

    this.options = {
      autoplay: {
        delay: 2000,
        disableOnInteraction: false,
      },      
      direction: 'vertical',
      wrapperClass: 'slides-list',
      slideClass: 'slide',
      centeredSlides: true,
      slidesPerView: 1,  // Default slides per view
      spaceBetween: 0,
      loop: true,
      grabCursor: false,
      navigation: {
        prevEl: '.slider__btn--prev',
        nextEl: '.slider__btn--next'
      },
      pagination: {
        el: '.slider__pagination',
        clickable: true,
      },
      speed: 1000,
      watchSlidesProgress: true,
      watchOverflow: true,
      on: {
        init: function () {
          // console.log('swiper initialized');
        },
      }
    };

    const breakpoint = 1200;
    const breakpointUnit = 'px'
    this.pageWidth = window.matchMedia(`(min-width: ${breakpoint}${breakpointUnit})`);

    this.isEnabled;
    this.classElement = `.${componentName}`;
    autoInit ? this.autoInit() : '';
  }


  init(component) {
    this.addCustomEvents(component);
  }


  autoInit() {
    if (this.pageWidth.matches) {
      this.slider = new Swiper(this.classElement, this.options);
      this.isEnabled = true;
      const sliderVertical = document.getElementsByClassName('splash-vertical-slider')[0]
      const langDropdown = document.getElementById('cmp-dropdown-languages_1')
      const langTextContent = langDropdown.getElementsByClassName('btn')[0].textContent
      const lang = langTextContent === 'EN' ? texts_en : langTextContent === 'ES' ? texts_es : texts_fr
      if(sliderVertical) {
        setTimeout(() => {
          const pagination =  sliderVertical.getElementsByClassName('swiper-pagination-bullet')
          for (let [i, bullet] of [...pagination].entries()) {
            bullet.textContent = lang[i]
          }
        }, 1000)
      }
    }
  }

  update() {
    this.slider = new Swiper(this.classElement, this.options);
    this.isEnabled = true;
  }

  addCustomEvents(component) {
    if(!!this.slider && this.slider.slides.length < 2) {
      this.slider.destroy(true, true);
    } else {
      window.addEventListener('resize', _.throttle((e) => {
        if (!this.isEnabled) {
          this.autoInit();
        }
  
      }, 500));
    }

  }

}

export default SliderVertical;
